import { Button, Flex, Modal, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  PageContainer,
  PageFooter,
  PageHeader,
  StepProps,
} from '../../../shared_components';
import classes from '../../../app.module.css';
import { useEffect, useState } from 'react';
import { useStore } from '../../../shared_hooks';
import { OrderDataStoreContext } from '../stores';
import { observer } from 'mobx-react-lite';
import {
  intervalTimeInMs,
  maxErrorWaitingTimeInMs,
  maxWaitingTimeInMs,
} from '../constants';
import { useDisclosure } from '@mantine/hooks';

export const StepWait = observer(({ forward, back }: StepProps) => {
  const { t } = useTranslation(['payment', 'common']);
  const [opened, { open, close }] = useDisclosure(false);
  const [timePassed, setTimePassed] = useState(0);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const orderDataStore = useStore(OrderDataStoreContext);
  const deviceId = localStorage.getItem('device_id');

  useEffect(() => {
    const interval = setInterval(() => {
      void orderDataStore.checkDeviceAvailability(deviceId || '');
      setTimePassed(
        (previousTimePassed) => previousTimePassed + intervalTimeInMs,
      );
    }, intervalTimeInMs);
    return () => clearInterval(interval);
  });

  useEffect(() => {
    if (orderDataStore.deviceAvailable || timePassed >= maxWaitingTimeInMs) {
      if (!orderDataStore.deviceAvailable) {
        if (buttonDisabled) {
          open();
        }
      }
      setButtonDisabled(false);
    }
  }, [
    buttonDisabled,
    setButtonDisabled,
    orderDataStore.deviceAvailable,
    timePassed,
    open,
  ]);

  useEffect(() => {
    if (
      orderDataStore.errorCheckingDeviceAvailability &&
      timePassed >= maxErrorWaitingTimeInMs
    ) {
      if (buttonDisabled) {
        open();
      }
      setButtonDisabled(false);
    }
  }, [
    orderDataStore.deviceAvailable,
    orderDataStore.errorCheckingDeviceAvailability,
    timePassed,
    buttonDisabled,
    open,
  ]);

  return (
    <PageContainer darkMode={true}>
      <Modal
        style={{ color: 'var(--mantine-color-clinicalWhite-0)' }}
        classNames={{ content: classes.modalContentWhite }}
        opened={opened}
        onClose={close}
        title={t('payment:timeout_modal_title')}
      >
        <Stack>
          <Text>
            {orderDataStore.errorCheckingDeviceAvailability
              ? t('payment:timeout_modal_message_error')
              : t('payment:timeout_modal_message')}
          </Text>
          <Button onClick={close}>{t('common:understood')}</Button>
        </Stack>
      </Modal>
      <Flex direction={'column'} justify={'space-between'} h={'100%'}>
        <Stack classNames={{ root: classes.footerPadding }}>
          <PageHeader
            title={t('waiting_title')}
            message={t('waiting_message')}
            darkMode
          />

          <video
            style={{ borderRadius: 'var(--mantine-radius-xl)' }}
            autoPlay
            playsInline
            muted
            loop
            id="qrVideo"
          >
            <source
              src={'../../../../assets/videos/test.mp4'}
              type={'video/mp4'}
            />
            Your browser does not support the html video tag.
          </video>
        </Stack>
        <PageFooter
          leftElement={
            <Flex direction={'column'} justify={'space-between'}>
              <Text variant="white">{t('more_info')}</Text>
              <Link
                to={'https://www.combyn.com'}
                style={{
                  color: 'var(--mantine-color-clinicalWhite-0)',
                  textDecoration: 'underline',
                }}
              >
                www.combyn.com
              </Link>
            </Flex>
          }
          buttonText={t('continue')}
          rightOnClick={forward}
          disabled={buttonDisabled}
        />
      </Flex>
    </PageContainer>
  );
});
